import _ from 'lodash';
import { opcoRef } from '../components/constant';

export function logout(appData) {
  const { REACT_APP_LOGOUT_URL } = appData;
  window.location.href = REACT_APP_LOGOUT_URL || '/ui/logout';
}

export function goToHomeURL(appData) {
  const { REACT_APP_HOME_URL } = appData;
  window.location.href = REACT_APP_HOME_URL || '/appHome';
}
export function goToOktaLogin(appData) {
  const { REACT_APP_HOME_URL } = appData;

  window.location.href = `${REACT_APP_HOME_URL}/oktaLogin` || 'ui/login/oktaLogin'
}



export function navigateTo(url) {
  window.location.href = url;
}

export function modifyFields(allItems, newItems, schema, gridName = '') {
  return allItems.map((x) => {
    const item = newItems.find(({ field }) => field === x.field);
    const itemType = schema[x.field];
    return {
      ...(item ? item : x),
      filter: [],
      enableMenu: false,
      aepColType: itemType,
      aepGrid: gridName,
    };
  });
}

export function opcoConverter(data) {
  return  data.value && _.findKey(opcoRef,data.value)
}

export function dateFormatter(data) {
  return data.value
    ? new Date(data.value)
        .toLocaleString('en-us', {
          hour12: false,
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        })
        .replace(',', '')
    : '';
}

export function dateComparator(filteredDate, cellValue) {
  const dateAsString = cellValue;

  if (dateAsString == null) {
    return 0;
  }
  let filterDateObj = new Date(filteredDate).toLocaleDateString().split('/');
  let year = Number(filterDateObj[2]);
  let month = Number(filterDateObj[0]);
  let day = Number(filterDateObj[1]);
  filterDateObj = new Date(year, month, day);
  // We create a Date object for comparison against the filter date
  const dateParts = new Date(dateAsString).toLocaleDateString().split('/');
  year = Number(dateParts[2]);
  month = Number(dateParts[0]);
  day = Number(dateParts[1]);
  const cellDate = new Date(year, month, day);
  console.log({ cellDate, filterDateObj });
  // Now that both parameters are Date objects, we can compare
  if (cellDate < filterDateObj) {
    return -1;
  } else if (cellDate > filterDateObj) {
    return 1;
  }
  return 0;
}

export function inRangeDateComparator(fromDate, toDate, cellvalue) {
  let d = new Date(cellvalue);
  let start = new Date(fromDate);
  let end = new Date(toDate);
  return isFinite((d = d.valueOf())) &&
    isFinite((start = start.valueOf())) &&
    isFinite((end = end.valueOf()))
    ? start <= d && d <= end
    : NaN;
}
export function downloadBlob(data, fileName) {
  const downloadUrl = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', fileName); //any other extension
  document.body.appendChild(link);
  link.click();
  link.remove();
}
export let amountFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export function isNumeric(value) {
  return /^-?\d+$/.test(value);
}
